import React, { useState } from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Best_1 from '../../../assets/images/home_page_3/best-product/01.png'
import Best_2 from '../../../assets/images/home_page_3/best-product/02.png'
import Best_3 from '../../../assets/images/home_page_3/best-product/03.png'
import Best_4 from '../../../assets/images/home_page_3/best-product/04.png'



// Custom Previous Arrow
const PrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <button type="button" className={`${className} slick-prev`} onClick={onClick}>
            <i className="flaticon-left-chevron" />
        </button>

    );
};

// Custom Next Arrow
const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <button type="button" className={`${className} slick-next`} onClick={onClick}>
            <i className="flaticon-chevron" />
        </button>

    );
};

const BestSlider = {
    slidesToShow: 4,
    Infinity: true,
    slidesToShow: 4,
    nav: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}



const BestProduct = () => {
    const [ActiveTab, setActiveTab] = useState('Shirt');

    const handleTabchange = (tab) => {
        setActiveTab(tab);
    }
    return (
        <>
            <section id="best-product-three" className="best-product-three-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section text-center">
                                <div className="section-sub-title">Best product</div>
                                <h4 className="section-title-three">New Best selling product</h4>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-10 offset-lg-1">
                                    <div className="best-product-three-tabs">
                                        <ul
                                            className="nav nav-pills"
                                            id="pills-tab-prodct-nav"
                                            role="tablist"
                                        >
                                            <li className="nav-item" role="presentation">
                                                <Link
                                                    className={`nav-link ${ActiveTab === "Shirt" ? "active" : ""}`}
                                                    onClick={() => handleTabchange("Shirt")}
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-shirt"
                                                    title=""
                                                    role="tab"
                                                    aria-controls="pills-shirt"
                                                    aria-selected="true"
                                                >
                                                    Shirt
                                                </Link>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <Link
                                                    className={`nav-link ${ActiveTab === "Jeans" ? "active" : ""}`}
                                                    onClick={() => handleTabchange("Jeans")}
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-jeans"
                                                    title=""
                                                    role="tab"
                                                    aria-controls="pills-jeans"
                                                    aria-selected="false"
                                                >
                                                    Jeans
                                                </Link>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <Link
                                                    className={`nav-link ${ActiveTab === "Pant" ? "active" : ""}`}
                                                    onClick={() => handleTabchange("Pant")}
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-pant"
                                                    title=""
                                                    role="tab"
                                                    aria-controls="pills-pant"
                                                    aria-selected="false"
                                                >
                                                    Pant's
                                                </Link>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <Link
                                                    className={`nav-link ${ActiveTab === "Wallet" ? "active" : ""}`}
                                                    onClick={() => handleTabchange("Wallet")}
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-wallet"
                                                    title=""
                                                    role="tab"
                                                    aria-controls="pills-wallet"
                                                    aria-selected="false"
                                                >
                                                    Wallet's
                                                </Link>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <Link
                                                    className={`nav-link ${ActiveTab === "Accessories" ? "active" : ""}`}
                                                    onClick={() => handleTabchange("Accessories")}
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#pills-accessories"
                                                    title=""
                                                    role="tab"
                                                    aria-controls="pills-accessories"
                                                    aria-selected="false"
                                                >
                                                    Accessories
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-content" id="pills-tabContent-prdct-nav">
                                <div
                                    className={`tab-pane fade ${ActiveTab === 'Shirt' ? 'show active' : ''}`}
                                    id="pills-shirt"
                                    role="tabpanel"

                                >
                                    <Slider className="slider best-product-three-autoplay" {...BestSlider}>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_1}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Jack&amp;jons Silk Shirt
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$30.02</s>
                                                    </li>
                                                    <li className="price">$24.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_2}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Smart Men's Bag
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$20.00</s>
                                                    </li>
                                                    <li className="price">$15.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_3}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Apex Seize Suite
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$42.02</s>
                                                    </li>
                                                    <li className="price">$24.71</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_4}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Smart Watch G-Shock
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$42.02</s>
                                                    </li>
                                                    <li className="price">$24.71</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_1}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Jack&amp;jons Silk Shirt
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$30.02</s>
                                                    </li>
                                                    <li className="price">$24.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                                <div
                                    className={`tab-pane fade ${ActiveTab === 'Jeans' ? 'show active' : ''}`}
                                    id="pills-jeans"
                                    role="tabpanel"

                                >
                                    <Slider className="slider best-product-three-autoplay"{...BestSlider}>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_1}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Jack&amp;jons Silk Shirt
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$30.02</s>
                                                    </li>
                                                    <li className="price">$24.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_2}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Smart Men's Bag
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$20.00</s>
                                                    </li>
                                                    <li className="price">$15.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_3}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Apex Seize Suite
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$42.02</s>
                                                    </li>
                                                    <li className="price">$24.71</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_4}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Smart Watch G-Shock
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$42.02</s>
                                                    </li>
                                                    <li className="price">$24.71</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_1}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Jack&amp;jons Silk Shirt
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$30.02</s>
                                                    </li>
                                                    <li className="price">$24.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                                <div
                                    className={`tab-pane fade ${ActiveTab === 'Pant' ? 'show active' : ''}`}
                                    id="pills-pant"
                                    role="tabpanel"

                                >
                                    <Slider className="slider best-product-three-autoplay" {...BestSlider}>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_1}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Jack&amp;jons Silk Shirt
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$30.02</s>
                                                    </li>
                                                    <li className="price">$24.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_2}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Smart Men's Bag
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$20.00</s>
                                                    </li>
                                                    <li className="price">$15.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_3}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Apex Seize Suite
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$42.02</s>
                                                    </li>
                                                    <li className="price">$24.71</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_4}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Smart Watch G-Shock
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$42.02</s>
                                                    </li>
                                                    <li className="price">$24.71</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_1}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Jack&amp;jons Silk Shirt
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$30.02</s>
                                                    </li>
                                                    <li className="price">$24.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                                <div
                                    className={`tab-pane fade ${ActiveTab === 'Wallet' ? 'show active' : ''}`}
                                    id="pills-wallet"
                                    role="tabpanel"

                                >
                                    <Slider className="slider best-product-three-autoplay" {...BestSlider}>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_1}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Jack&amp;jons Silk Shirt
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$30.02</s>
                                                    </li>
                                                    <li className="price">$24.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_2}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Smart Men's Bag
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$20.00</s>
                                                    </li>
                                                    <li className="price">$15.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_3}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Apex Seize Suite
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$42.02</s>
                                                    </li>
                                                    <li className="price">$24.71</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_4}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Smart Watch G-Shock
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$42.02</s>
                                                    </li>
                                                    <li className="price">$24.71</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_1}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Jack&amp;jons Silk Shirt
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$30.02</s>
                                                    </li>
                                                    <li className="price">$24.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                                <div
                                    className={`tab-pane fade ${ActiveTab === 'Accessories' ? 'show active' : ''}`}
                                    id="pills-accessories"
                                    role="tabpanel"

                                >
                                    <Slider className="slider best-product-three-autoplay" {...BestSlider}>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_1}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Jack&amp;jons Silk Shirt
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$30.02</s>
                                                    </li>
                                                    <li className="price">$24.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_2}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Smart Men's Bag
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$20.00</s>
                                                    </li>
                                                    <li className="price">$15.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_3}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Apex Seize Suite
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$42.02</s>
                                                    </li>
                                                    <li className="price">$24.71</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_4}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Smart Watch G-Shock
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$42.02</s>
                                                    </li>
                                                    <li className="price">$24.71</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="best-product-three-block">
                                            <div className="best-product-three-img text-center">
                                                <Link to="/ShopDetails" title="">
                                                    <img
                                                        src={Best_1}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                            <div className="best-product-three-dtls">
                                                <h6 className="best-product-three-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        Jack&amp;jons Silk Shirt
                                                    </Link>
                                                </h6>
                                                <ul className="best-product-three-price">
                                                    <li className="discount-price">
                                                        <s>$30.02</s>
                                                    </li>
                                                    <li className="price">$24.00</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default BestProduct
